__turbopack_context__.v({
  "button": "button-module-scss-module__e93k7W__button",
  "button--isMenu": "button-module-scss-module__e93k7W__button--isMenu",
  "narrow": "button-module-scss-module__e93k7W__narrow",
});
